import { useState, useEffect, useContext } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Msg, Button } from 'react-weui';
import PropTypes from 'prop-types';
import { formatDate, formatNumber } from 'lib/formatter.ts';
import Http from 'services/http2';
import User from 'services/user2';
import TopNav from 'components/topNav.js';
import * as MobileActions from 'actions/index.ts';
import CompanyService from 'services/company2';
//审批流状态
import WorkflowStatus from 'components/workflowStatus.jsx';
//审批流按钮
import WorkflowButtons from 'components/workflowButtons.jsx';
import Util from 'lib/util.js';
import useDetail from 'hooks/useDetail';
import EnumService from 'services/enum2';
import IqcService from 'services/iqc';
import { ActionContext } from 'actions/context';
import Modal from 'components/modal';
import ModalService from 'services/modal';
import CommonFns from 'functions/common.ts';
import Download from 'components/download.js';
import Big from 'big.js';

function I8dReportDetail(props) {
  const Config = {
    purchase: {
      title: '8D报告详情',
      apiPath: '/verifyP8dReport/getDetail',
      publishApiPath: '/verifyP8dReport/publish',
      auditApiPath: '/verifyP8dReport/audit',
      customerNameKey: 'companyName',
      companyCodeKey: 'companyCode',
      vendorNameKey: 'innerVendorName',
      arrEnumField: [
        {
          mainKey: 'B02_Product8D_Report_Status',
          subKey: 'status',
          value: 'statusName'
        },
        {
          mainKey: 'B02_Product8D_Report_Bad_Type',
          subKey: 'badType',
          value: 'badTypeName'
        }
      ],
      idField: 'p8dXkNo',
      wfmCode: '1009'
    },
    sale: {
      title: '8D报告详情',
      apiPath: '/customerVerifyP8d/getDetail',
      // deleteApiPath: '/cCostsheetOrder/delete',
      customerNameKey: 'companyName',
      vendorNameKey: 'innerCustomerName',
      arrEnumField: [
        {
          mainKey: 'B02_Product8D_Report_Status',
          subKey: 'status',
          value: 'statusName'
        },
        {
          mainKey: 'B02_Product8D_Report_Bad_Type',
          subKey: 'badType',
          value: 'badTypeName'
        }
      ],
      idField: 'p8dXkNo'
    }
  };

  const config = Config[props.type];

  const {
    companyCode,
    inited,
    error,
    updateTs,
    redirect,
    moreSign1,
    moreSign2,
    handleMore,
    decimalPlace,
    fileList,
    setShowLoading,
    setError,
    setFileList,
    setRedirect,
    detail,
    setDetail,
    workflow,
    forceUpdate,
    self
  } = useDetail(props, config);

  const { state, dispatch } = useContext(ActionContext);
  const [boxState, setBoxState] = useState({
    1: true
  });

  const [canRecall, setCanRecall] = useState(false); //客户对账单是否可以撤回/
  const [companyParams, setCompanyParams] = useState({});

  //处理详情数据
  self.afterGetDetail = function (data) {
    //单身枚举
    data.detailList.forEach((item, i) => {
      EnumService.getValue('B02_Progress_Indicator_Status', item.status).then(
        value => {
          item.statusName = value;
          forceUpdate();
        }
      );
      //详细描述空格转化
      if (item.description) {
        let clause = item.description.replace(
          /\t/g,
          '&nbsp;&nbsp;&nbsp;&nbsp;'
        );
        clause = clause.replace(/\r\n/g, '<br/>');
        clause = clause.replace(/\n/g, '<br/>');
        clause = clause.replace(/\s/g, ' ');
        item.descriptionShow = clause;
        forceUpdate();
      }
    });
    setDetail(data);
  };

  //初始化默认企业
  useEffect(() => {
    const { match } = props;
    let routeCompanyCode = match.params.companyCode;
    self.init(routeCompanyCode);
    //卸载时
    return function unmount() {
      if (self.toastTimer) {
        clearTimeout(self.toastTimer);
      }
      if (self.loadingTimer) {
        clearTimeout(self.loadingTimer);
      }
      if (self.errorTimer) {
        clearTimeout(self.errorTimer);
      }
    };
  }, [self, props]);

  //根据依赖多次执行
  useEffect(() => {
    self.getDetail();
  }, [companyCode, self]);

  // function handleBoxState(idx) {
  //   boxState[idx] = !boxState[idx];
  //   setBoxState(boxState);
  //   forceUpdate();
  // }

  //确认发出
  function publish() {
    let postbody = getPostbody(config.publishApiPath);
    IqcService.publish8dOrder(
      postbody,
      () => {
        self.getDetail();
      },
      dispatch
    );
  }

  //审核
  function auditOk() {
    let postbody = getPostbody(config.auditApiPath);
    IqcService.audit8dOrder(
      postbody,
      () => {
        self.getDetail();
      },
      dispatch
    );
  }

  function showFileList(item, i, id) {
    const { actions } = props;
    let cCode = item.companyCode;
    setShowLoading(true);
    CompanyService.getFileList(31, item.uniqueKey, '', '', cCode).then(res => {
      setShowLoading(false);
      if (Array.isArray(res)) {
        let arr = res.map(row => {
          return { ...row };
        });
        setFileList(arr);
      }
    });
    actions.openDownloadModal();
  }

  //获取提交参数
  function getPostbody(apiPath) {
    let postbody = {
      p8dXkNo: self.id,
      companyCode: companyCode,
      apiPath: apiPath
    };
    return postbody;
  }

  //显示错误
  if (error !== null) {
    return <Msg {...error} />;
  }

  if (redirect !== null) {
    return <Redirect to={redirect} />;
  }

  return (
    <div>
      <TopNav inited={inited} />
      <div className="m-details-container">
        <div className="m-details-item">
          <div className="details-item-title">
            <label>基础信息</label>
          </div>
          <div className="details-item-content">
            <div className="content-line">
              <ul className="field-list">
                {self.isPurchase && (
                  <li>
                    <span className="field-label">供应商</span>
                    <div className="field-value">
                      {detail[config.vendorNameKey]}({detail.innerVendorCode})
                    </div>
                  </li>
                )}
                {!self.isPurchase && (
                  <li>
                    <span className="field-label">客户名称</span>
                    <div className="field-value">
                      {detail[config.vendorNameKey]}({detail.innerCustomerCode})
                    </div>
                  </li>
                )}
                <li>
                  <span className="field-label">报告编号</span>
                  <div className="field-value">{detail.p8dInnerNo}</div>
                </li>
                <li>
                  <span className="field-label">报告部门</span>
                  <div className="field-value">{detail.departmentName}</div>
                </li>
                <li>
                  <span className="field-label">物料编码</span>
                  <div className="field-value">{detail.productCode}</div>
                </li>
                <li>
                  <span className="field-label">物料名称</span>
                  <div className="field-value">{detail.productName}</div>
                </li>
                <li>
                  <span className="field-label">物料规格</span>
                  <div className="field-value">{detail.productScale}</div>
                </li>
                <li>
                  <span className="field-label">状态</span>
                  <div className="field-value">
                    <span
                      className={
                        'u-sign ' +
                        CommonFns.getStatusClass(
                          'B02_Product8D_Report_Status',
                          detail.status
                        )
                      }
                    >
                      {detail.statusName}
                    </span>
                  </div>
                </li>

                {/* 审批流状态 仅开启后才显示 */}
                {self.isPurchase && updateTs > 0 && workflow.isActive && (
                  <li>
                    <span className="field-label">审批环节</span>
                    <div className="field-value">
                      <WorkflowStatus
                        companyCode={companyCode}
                        id={self.id}
                        workflow={workflow}
                        detail={detail}
                      />
                    </div>
                  </li>
                )}
                {/* 审批流按钮 */}
                {self.isPurchase && updateTs > 0 && workflow.isActive && (
                  <li>
                    <span className="field-label">审批操作</span>
                    <div className="field-value">
                      <WorkflowButtons
                        companyCode={companyCode}
                        id={self.id}
                        workflow={workflow}
                        detail={detail}
                        onChange={() => {
                          self.getDetail();
                        }}
                      />
                    </div>
                  </li>
                )}
                <li>
                  <span className="field-label">缺陷数量</span>
                  <div className="field-value">{detail.defectiveQty}</div>
                </li>
                <li>
                  <span className="field-label">发生时间</span>
                  <div className="field-value">
                    {formatDate(detail.happenTime, 'YYYY-MM-DD')}
                  </div>
                </li>
                <li>
                  <span className="field-label">批次数量</span>
                  <div className="field-value">{detail.batchQty}</div>
                </li>
                <li>
                  <span className="field-label">缺陷率</span>
                  <div className="field-value">
                    {detail.defectiveRate * 100} %
                  </div>
                </li>
                <li>
                  <span className="field-label">检验单号</span>
                  <div className="field-value">{detail.vfoInnerNo}</div>
                </li>
                <li>
                  <span className="field-label">不良原因</span>
                  <div className="field-value">{detail.badReason}</div>
                </li>
                <li>
                  <span className="field-label">不良说明</span>
                  <div className="field-value">{detail.badDesc}</div>
                </li>
                <li>
                  <span className="field-label">不良类型</span>
                  <div className="field-value">{detail.badTypeName}</div>
                </li>
              </ul>
            </div>
          </div>
          {/* <div
            className={moreSign1 ? 'm-more' : 'm-more m-more-open'}
            onClick={() => {
              handleMore(1);
            }}
          >
            {moreSign1 && '更多'}
            {!moreSign1 && '收起'}
            <i className="icon-down"></i>
          </div> */}
        </div>

        {/*8D报告单 */}
        {!Util.isEmpty(detail.detailList) && (
          <div className="m-details-item">
            <div className="details-item-title">
              <label>8D报告明细</label>
            </div>

            <div className="details-item-content">
              {detail.detailList.map((item, index) => (
                <div className="content-line line-list-item" key={index}>
                  <div className="line-list-item-title">
                    <span>
                      {item.itemCode}-{item.itemName}
                    </span>
                  </div>
                  <ul className="field-list">
                    <li>
                      <span className="field-label">开始日期</span>
                      <div className="field-value">
                        {formatDate(item.startTime, 'YYYY-MM-DD')}
                      </div>
                    </li>
                    <li>
                      <span className="field-label">预计完成日期</span>
                      <div className="field-value">
                        {formatDate(item.endTime, 'YYYY-MM-DD')}
                      </div>
                    </li>
                    <li>
                      <span className="field-label">负责人</span>
                      <div className="field-value">{item.headName}</div>
                    </li>
                    <li>
                      <span className="field-label">附件</span>
                      <div className="field-value">
                        {!Util.isEmpty(item.fileMd5s) &&
                          item.fileMd5s.length > 0 && (
                            <span
                              className="attachment"
                              onClick={() => showFileList(item, index)}
                            >
                              {item.fileMd5s.length}个附件
                              <i className="icon-attachment"></i>
                            </span>
                          )}
                      </div>
                    </li>
                    <li>
                      <span className="field-label">状态</span>
                      <div className="field-value">{item.statusName}</div>
                    </li>

                    <li>
                      <span className="field-label">说明</span>
                      <div className="field-value">
                        <div
                          className="f-d-ib"
                          dangerouslySetInnerHTML={{
                            __html: item.descriptionShow
                          }}
                        ></div>
                      </div>

                      {/* <span dangerouslySetInnerHTML={{__html: item.descriptionShow}}></span> */}
                    </li>
                  </ul>
                </div>
              ))}
            </div>
          </div>
        )}

        {!Util.isEmpty(detail.reportTraceList) && (
          <div className="m-details-item">
            <div className="details-item-title">
              <label>改善跟踪</label>
            </div>
            <div className="details-item-content">
              {detail.reportTraceList.map((item, index) => (
                <div className="content-line line-list-item" key={index}>
                  <div className="line-list-item-title">
                    <span>序号 {index + 1}</span>
                  </div>
                  <ul className="field-list">
                    <li>
                      <span className="field-label">检验单号</span>
                      <div className="field-value">{item.vfoInnerNo}</div>
                    </li>
                    <li>
                      <span className="field-label">检验日期</span>
                      <div className="field-value">
                        {formatDate(item.verifyTime, 'YYYY-MM-DD HH:mm')}
                      </div>
                    </li>
                    <li>
                      <span className="field-label">检验结果</span>
                      <div className="field-value">
                        {item.resultFlag ? '合格' : '不合格'}
                      </div>
                    </li>
                    <li>
                      <span className="field-label">不良原因</span>
                      <div className="field-value">{item.badReasonName}</div>
                    </li>
                    <li>
                      <span className="field-label">不良数量</span>
                      <div className="field-value">{item.badQty}</div>
                    </li>
                    <li>
                      <span className="field-label">检验数量</span>
                      <div className="field-value">{item.checkQty}</div>
                    </li>
                    <li>
                      <span className="field-label">送货数量</span>
                      <div className="field-value">{item.deliveryQty}</div>
                    </li>
                    <li>
                      <span className="field-label">报告结果</span>
                      <div className="field-value">
                        {detail.reportResult === 0
                          ? '不合格'
                          : detail.reportResult === 1
                          ? '合格结案'
                          : detail.reportResult === 2
                          ? '强制结案'
                          : ''}
                      </div>
                    </li>
                  </ul>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
      {self.isPurchase && (
        <div className="wrap m-flex-box fixed-bottom">
          {User.checkAuth('10080504') &&
            [0, 5].includes(detail.status) &&
            workflow.data &&
            workflow.data['8D_publish_1'].complete && (
              <Button
                type="default"
                onClick={() => {
                  publish();
                }}
                className="m-flex-item u-btn u-btn_primary"
              >
                确认发出
              </Button>
            )}

          {User.checkAuth('10080506') &&
            [4].includes(detail.status) &&
            workflow.data &&
            workflow.data['8D_cfm_4'].complete && (
              <Button
                type="default"
                onClick={() => {
                  auditOk();
                }}
                className="m-flex-item u-btn u-btn_primary"
              >
                审核
              </Button>
            )}
        </div>
      )}
      {/* <span
          *ngIf="
            user.checkAuth('10080506') &&
            [4].includes(detail.status) &&
            workflow.data &&
            workflow.data['8D_cfm_4'].complete
          "
          class="u-btn"
          (click)="auditOk()"
          >{{ 'BUTTON.AUDIT' | translate }}</span
        > */}

      {
        // 附件查看
        Array.isArray(fileList) && fileList.length > 0 && (
          <Download fileList={fileList} />
        )
      }
      <Modal></Modal>
    </div>
  );
}

I8dReportDetail.propTypes = {
  data: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  return {
    data: state.login
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(I8dReportDetail);
